import * as React from "react";
import { DeleteSnapshotsDialog } from "@/components/snapshots/DeleteSnapshotsDialog";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  count: number;
  /** Inside a sub-collection the snapshots are only removed from it, so the copy says "Remove". */
  isSubcollection: boolean;
  onConfirmDelete: () => void | Promise<void>;
  isDeleting: boolean;
}

export const DeleteSelectedSnapshotsDialog: React.FC<Props> = ({
  open,
  onOpenChange,
  count,
  isSubcollection,
  onConfirmDelete,
  isDeleting,
}) => (
  <DeleteSnapshotsDialog
    open={open}
    onOpenChange={onOpenChange}
    snapshotCount={count}
    title={isSubcollection ? `Remove ${count} Snapshot${count !== 1 ? "s" : ""}?` : undefined}
    description={
      isSubcollection
        ? `This will remove ${count} snapshot${count !== 1 ? "s" : ""} from this sub-collection only. The snapshot${count !== 1 ? "s" : ""} will remain in the parent collection and any other sub-collections.`
        : undefined
    }
    confirmLabel={isSubcollection ? "Remove" : undefined}
    loadingLabel={isSubcollection ? "Removing..." : undefined}
    onConfirmDelete={onConfirmDelete}
    isDeleting={isDeleting}
  />
);
